import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import "./History.css";
import { Images } from "../../helpers/Images";

const HistoryTemplate = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add your form submission logic
    console.log("Form submitted:", formData);
  };

  const scrollToForm = () => {
    document
      .getElementById("contact-form")
      .scrollIntoView({ behavior: "smooth" });
  };

  const historyData = [
    {
      year: 2025,
      title: "AI Farm",
      sdg: "SDG 12: Responsible Consumption and Production",
      description:
        "This year’s theme emphasizes the integration of AI and robotics in agriculture to achieve sustainable and efficient food production. Participants are challenged to design smart farming systems that reduce resource waste, optimize crop yields, and promote eco-friendly practices. The competition encourages forward-thinking solutions for a more resilient and responsible food system.",
      sdgImage: Images.sdg12, // Replace with actual SDG 12 image
      // matImage: Images.mat2021, // Replace with actual mat image
    },
    {
      year: 2024,
      title: "Doctor Robot",
      description:
        "In 2024, the challenge spotlighted healthcare innovations through robotics and AI. Participants developed intelligent medical assistant systems aimed at enhancing diagnostics, supporting patient care, and automating health services. This edition demonstrated how robotics can revolutionize the medical field and improve the quality of life.",
      sdg: "SDG 3: Good Health and Well-being",
      sdgImage: Images.sdg3, // Replace with actual SDG 3 image
      matImage: Images.mat2024, // Replace with actual mat image
    },
    {
      year: 2023,
      title: "Food Security",
      sdg: "SDG 2: Zero Hunger",
      description:
        "This year focused on combating hunger and promoting sustainable agriculture. Participants used robotics and artificial intelligence to propose innovative farming techniques, improve food distribution systems, and support communities in need. The theme highlighted how technology can help ensure access to nutritious food for all.",
      sdgImage: Images.sdg2, // Replace with actual SDG 2 image
      matImage: Images.mat2023, // Replace with actual mat image
    },
    {
      year: 2022,
      title: "Climate Change",
      sdg: "SDG 13: Climate Action",
      description:
        "The 2022 theme inspired participants to develop robotic solutions that address the urgent issue of climate change. Competitors worked on projects aimed at reducing greenhouse gas emissions, improving energy efficiency, and raising awareness of environmental sustainability. This edition emphasized the critical role technology can play in mitigating the effects of global warming.",
      sdgImage: Images.sdg13, // Replace with actual SDG 13 image
      matImage: Images.mat2022, // Replace with actual mat image
    },
    {
      year: "2020-2021",
      title: "Save the Seas",
      description:
        "In these two years, the competition centered on preserving marine ecosystems and reducing ocean pollution. Participants were tasked with designing robotic and programming-based solutions to monitor marine environments, remove waste from oceans, and protect aquatic life. The challenge promoted awareness of environmental issues affecting the seas and encouraged innovative, tech-driven approaches to ocean conservation.",
      sdg: "SDG 14: Life Below Water",
      sdgImage: Images.sdg14, // Replace with actual SDG 14 image
      matImage: Images.mat2021, // Replace with actual mat image
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), url(${Images.website})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            We Do Challenge History
          </Typography>
          <Typography
            variant="h5"
            sx={{
              maxWidth: "900px",
              margin: "0 auto",
              fontSize: { xs: "0.8rem", md: "1.1rem" },
            }}
          >
            The We Do Challenge (WDC) aligns with multiple Sustainable
            Development Goals (SDGs) by encouraging young minds to engage in
            robotics, programming, problem-solving, and innovation. Each year,
            the competition selects a theme focusing on a specific SDG, helping
            participants understand and address global challenges through
            technology.
          </Typography>
        </Box>
      </Box>

      {/* History Timeline Section */}
      <Box
        sx={{
          pt: 4,
          pb: 8,
          px: { xs: 2, md: 4 },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Grid container spacing={4}>
          {historyData.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  boxShadow: 3,
                  borderRadius: 2,
                  overflow: "hidden",
                  justifyContent: "space-between",
                }}
              >
                <CardContent
                  sx={{
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: "130px", md: "140px" },
                          height: { xs: "130px", md: "140px" },
                          mr: 2,
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src={item.sdgImage}
                          alt={`SDG for ${item.title}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h4"
                          sx={{
                            color: "#1976d2",
                            fontWeight: "bold",
                            mb: 0.5,
                          }}
                        >
                          {item.year}
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "bold",
                            mb: 0.5,
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "#666",
                          }}
                        >
                          {item.sdg}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      {item.description}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                    }}
                  >
                    {item.matImage ? (
                      <img
                        src={item.matImage}
                        alt={`Competition mat for ${item.title}`}
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      <Typography
                        variant="h3"
                        sx={{
                          color: "#1976d2",
                          fontWeight: "bold",
                          textAlign: "center",
                          my: { xs: 4, md: 10 },
                        }}
                      >
                        Coming Soon
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default HistoryTemplate;
